import { RoadCapturePlanStep, RoadLayoutStep } from '../../components/contributions/RoadSurveyPlanningSteps';
import type { StripCaptureMode } from '../../utils/roadStripSurvey';

export interface RoadGeometryWizardProps {
  step: string;
  carriagewayCount: number | null;
  singleStripCaptureMode: StripCaptureMode;
  onSingleStripCaptureModeChange: (mode: StripCaptureMode) => void;
  stripACaptureMode: StripCaptureMode;
  onStripACaptureModeChange: (mode: StripCaptureMode) => void;
  stripBCaptureMode: StripCaptureMode;
  onStripBCaptureModeChange: (mode: StripCaptureMode) => void;
  capturePlanError: string | null;
  onLayoutSelectSingle: () => void;
  onLayoutSelectDivided: () => void;
  onCapturePlanContinue: () => void;
}

/** Layout + capture-plan steps for motor road survey (policy §2.14). */
export function RoadGeometryWizard({
  step,
  carriagewayCount,
  singleStripCaptureMode,
  onSingleStripCaptureModeChange,
  stripACaptureMode,
  onStripACaptureModeChange,
  stripBCaptureMode,
  onStripBCaptureModeChange,
  capturePlanError,
  onLayoutSelectSingle,
  onLayoutSelectDivided,
  onCapturePlanContinue,
}: RoadGeometryWizardProps) {
  if (step === 'road_layout') {
    return (
      <RoadLayoutStep
        onSelectSingle={onLayoutSelectSingle}
        onSelectDivided={onLayoutSelectDivided}
      />
    );
  }
  if (step === 'road_capture_plan' && carriagewayCount != null) {
    return (
      <RoadCapturePlanStep
        carriagewayCount={carriagewayCount}
        singleStripCaptureMode={singleStripCaptureMode}
        onSingleStripCaptureModeChange={onSingleStripCaptureModeChange}
        stripACaptureMode={stripACaptureMode}
        onStripACaptureModeChange={onStripACaptureModeChange}
        stripBCaptureMode={stripBCaptureMode}
        onStripBCaptureModeChange={onStripBCaptureModeChange}
        validationError={capturePlanError}
        onContinue={onCapturePlanContinue}
      />
    );
  }
  return null;
}
